import React, { useState } from 'react';
import uuidValidate from "uuid-validate";
import Paper from '@material-ui/core/Paper';
import { NavLink } from "react-router-dom";
import { deleteAuthorizationKey } from "../../utils/api";

const SearchBar = ({ searchValue, searchHandler, resetHandler, inputChangeHandler }: any): JSX.Element => {

    const [isInValidSearch, setInValidSearch] = useState(false as boolean);

    const handleInputChangeHandler = (e: any) => {
        inputChangeHandler(e.target.value);
        setInValidSearch(false);
    }

    const handleSearchHandler = (event: any) => {
        if (event.key === 'Enter') {
            if (!uuidValidate(searchValue, 4)) {
                setInValidSearch(true);
            } else {
                searchHandler();
            }
        }
    }
    const handleResetHandler = () => {
        setInValidSearch(false);
        resetHandler();
    }
    const logOut = () => {
        deleteAuthorizationKey(["token", "subscriberCode"]);
    }
    return (
        <Paper id="searchBar" className="bg-dark border-0">
            <div className="row align-items-center mx-0">
                <div className="col-4">
                    <h5 className="mb-0">UE Xplorer</h5>
                </div>
                <div className="col-4 position-relative px-0" >
                    <div className={`input-group search-input w-100 }`}>
                        <input
                            className={`form-control search-input ${isInValidSearch ? "is-invalid" : ""}`}
                            id="searchInput"
                            type="text"
                            value={searchValue}
                            aria-label="Search"
                            maxLength={36}
                            onChange={handleInputChangeHandler}
                            size={38}
                            placeholder="Search for transaction Id"
                            onKeyDown={handleSearchHandler}
                        />
                        <div className="input-group-append">
                            <span className="input-group-text" onClick={handleResetHandler}>
                                {searchValue.length ? <i className="fa fa-close" /> : <i className="fa fa-search" />}
                            </span>
                        </div>

                        <div className="invalid-tooltip">
                            Invalid transaction Id entered.
                 </div>
                    </div>
                </div>
                <div className="col-4 px-1 d-flex justify-content-end" onClick={logOut}>
                    <NavLink to="/login" className="btn btn-light btn-sm" style={{ fontWeight: 600 }}>Log out
                    </ NavLink >
                </div>
            </div>
        </Paper>
    )
}
export default SearchBar;

